/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  AbstractFormComponent,
  BuilderNavigationService,
  BuilderUserContext,
  CommonActions,
  FormActionPipelines,
  FormFlowState,
} from '@gh/builder-shared';
import { AelEvents, getAelEventsArray } from '@gh/builder-shared-data';
import { ActionFlow, getRouteInitData, TextDictionary } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { valueComparator } from '@gh/core-util';
import { assign } from 'lodash';
import { OfficeRolePermissionsBusinessService } from '../../../resources/office-role-permissions-business.service';
import { OfficeRoleTodoPermissions } from '../../../resources/office-role-todo-permission.model';
import { OfficeRoleTodoPermissionTabFormState } from './office-role-todo-permission-tab-form.service';

@Component({
  standalone: false,
  selector: 'gh-letter-template-list-tab',
  templateUrl: 'office-role-todo-permission-tab.component.html',
  providers: [
    OfficeRoleTodoPermissionTabFormState,
  ],
})
export class OfficeRoleTodoPermissionTabComponent extends AbstractFormComponent<OfficeRoleTodoPermissions>
  implements OnInit {
  permissions: OfficeRoleTodoPermissions;
  permissionDictionary: TextDictionary;
  officeRoleId: ID;

  constructor(private route: ActivatedRoute,
              private navigationService: BuilderNavigationService,
              public form: OfficeRoleTodoPermissionTabFormState,
              private businessService: OfficeRolePermissionsBusinessService,
              private pipelines: FormActionPipelines,
              private commonActions: CommonActions,
              private userContext: BuilderUserContext) {
    super();
  }

  get completeFlow(): ActionFlow<FormFlowState<OfficeRoleTodoPermissions>> {
    return this.pipelines.complete({
      execute: this.commonActions.execute((state) =>
        this.businessService.saveTodoPermissions(state.value),
      ),
      finish: (state: FormFlowState<OfficeRoleTodoPermissions>) => {
        const { value } = state;

        this.form.build(value);
      },
    });
  }

  ngOnInit(): void {
    const { permissions, permissionDictionary, officeRoleId } = getRouteInitData(this.route);

    assign(this, {
      permissions,
      permissionDictionary: permissionDictionary.sort(valueComparator(({ name }) => name.toLowerCase())),
      officeRoleId,
    });
    this.form.build(permissions);
  }

  goToAel(): void {
    this.navigationService.goToAel({
      entityId: this.officeRoleId,
      entityType: 'OFFICE_ROLE',
      eventTypeIds: getAelEventsArray(AelEvents.OfficeRolePermissions.EditedToDo),
      label: 'lbl_office_roles_todo_permissions',
    });
  }
}
